
/* injects from baggage-loader */

'use strict';

import AccountInvestmentsController from './account.investments.controller';
import AccountInvestmentsTemplate from './account.investments.html';

export default class AccountInvestmentsComponent {
		constructor() {
				this.templateUrl = AccountInvestmentsTemplate;
				this.controller = AccountInvestmentsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					investments: '<'
				};
		}
}
